import { Directive, ElementRef, EventEmitter, Output } from '@angular/core';
// import '../../googleapis/google-maps.js';

declare var google: any;

@Directive({
	selector: '[appGooglePlaces]'
})
export class GooglePlacesDirective {
	@Output() setAddress: EventEmitter<any> = new EventEmitter();
	autocomplete: any;
	private _el: HTMLElement;

	constructor(el: ElementRef) {
		this._el = el.nativeElement;
		const input = this._el;

		this.autocomplete = new google.maps.places.Autocomplete(input, {});
		google.maps.event.addListener(this.autocomplete, 'place_changed', () => {
			const place = this.autocomplete.getPlace();
			this.invokeEvent({
				lat: place.geometry.location.lat(),
				lng: place.geometry.location.lng(),
				address: place.formatted_address
			});
		});
	}

	invokeEvent(place: Object) {
		this.setAddress.emit(place);
	}
}
